module.exports = __webpack_public_path__ + "img/bg1.b85883a7.png";